import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'La primera puerta balcón me dejó $480.000 de ganancia. El combo se pagó 24 veces.',
  author: 'Marcelo R.',
  location: 'Buenos Aires'
}, {
  quote: 'Primer trabajo sin perfiles quemados en mi vida. Los descuentos del Tomo 4 son oro.',
  author: 'Jorge C.',
  location: 'Rosario'
}, {
  quote: 'Subí mis precios 40% y cerré más trabajos que antes.',
  author: 'Sofía V.',
  location: 'Córdoba'
}];
export function ProofSection() {
  return <section className="py-10 bg-[#2C2C2C] text-white" data-id="element-157">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-158">
        <div className="grid md:grid-cols-3 gap-4" data-id="element-159">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-matte p-6 border-l-4 border-gold shadow-lg flex flex-col justify-between" data-id="element-160">
              <div data-id="element-161">
                <div className="flex mb-3" data-id="element-162">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-gold fill-gold" data-id="element-163" />)}
                </div>
                <p className="text-base font-bold italic text-gray-200 mb-4 leading-snug" data-id="element-164">
                  "{t.quote}"
                </p>
              </div>
              <div className="border-t border-silver/20 pt-3 mt-auto" data-id="element-165">
                <p className="font-black text-white text-sm uppercase tracking-wide" data-id="element-166">
                  {t.author}
                </p>
                <p className="text-xs text-gold font-medium" data-id="element-167">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}